// Local extension until the reduce fields land in @luxuryescapes/contract-svc-order.
type CancellationConfigWithReduce = App.CancellationConfig & {
  can_reduce_dates?: boolean | null
  block_reasons?: {
    block_date_reduce_reasons?: Array<App.BlockDateReduceReason>
  }
}

export default function orderCancellationConfigMap(config?: CancellationConfigWithReduce): App.OrderItemHotelCancellationConfig {
  return {
    policyType: config?.policy_type || 'non-refundable',
    policyDeadline: config?.policy_deadline || '',
    canUseBookingProtection: config?.can_use_booking_protection || false,
    canUseInsuranceBookingProtection: config?.can_use_insurance_booking_protection ?? false,
    canUseCancellationProtection: config?.can_use_cancellation_protection || false,
    canAutoRefund: config?.can_auto_refund || false,
    canRequestRefund: config?.can_request_refund || false,
    canRefundToOrigin: config?.can_refund_to_origin || false,
    canRefundToCredit: config?.can_refund_to_credit || false,
    changeOfMindEndDate: config?.change_of_mind_end_date ?? undefined,
    canRefund: config?.can_refund || false,
    blockAutoRefundReasons: config?.block_auto_refund_reasons || [],
    canChangeGuestName: config?.can_change_guest_name ?? false,
    blockGuestNameChangeReasons: config?.block_guest_name_change_reasons || [],
    canChangeDates: config?.can_change_dates ?? false,
    canExtendDates: config?.can_extend_dates ?? false,
    canReduceDates: config?.can_reduce_dates ?? false,
    blockDateReduceReasons: config?.block_reasons?.block_date_reduce_reasons || [],
    canRequestDateChange: config?.can_request_date_change ?? false,
    canUpgradePackage: config?.can_upgrade_package || false,
    luxProtectEligible: config?.lux_protect_eligible,
    jetstarVoucherEligible: config?.jetstar_voucher_eligible,
  }
}
